import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceService } from '../../../../../client/app/device.service';
import { BrowserNotCompatibleDialogBodyComponent } from '../browser-not-compatible-dialog-body/browser-not-compatible-dialog-body.component';

@Component({
    selector: 'app-browser-not-compatible-dialog',
    template: ''
})
export class BrowserNotCompatibleDialogComponent implements OnInit {
    constructor(private readonly deviceService: DeviceService, public dialog: MatDialog) {}

    ngOnInit() {
        // Check browser compatibility
        if (!this.deviceService.isBrowserCompatible()) {
            // Get device info
            const deviceInfo = this.deviceService.getDeviceInfo();

            // Get minimum supported version for browser
            const minVersion = this.deviceService.getMinimalSupportedVersion(deviceInfo.browser);

            // Show dialog
            this.dialog.open(BrowserNotCompatibleDialogBodyComponent, {
                data: { deviceInfo: deviceInfo, browserMinVersion: minVersion },
                disableClose: true,
                closeOnNavigation: false,
                hasBackdrop: true
            });
        }
    }
}
